import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Button, Icon, Modal, Tooltip} from "antd"
import ModalReGenerate from "./ModalReGenerate"
import {printedFileRetry} from "../../../../../services/api/3dApi"

class JobReGenerate extends Component {
    state = {
        error: '',
        loading: false,
        showModal: false,
        data: []
    }

    _handleModal = () => {
        this.setState({
            showModal: !this.state.showModal
        })
    }

    _handleReGen = async () => {
        Modal.confirm({
            content: 'Bạn chắc chắn muốn xử lý lại file in này?',
            cancelText: 'Hủy',
            okText: 'Đồng ý',
            onOk: async () => {
                await this._handleRetryGenerate()
                //await this._handleModal()
            }
        })
    }

    _handleRetryGenerate = async () => {
        try {
            const {sessionId, reloadListSessions} = this.props

            this.setState({
                error: '',
                loading: true
            })

            const payload = {
                session_id: sessionId
            }

            const {data: response} = await printedFileRetry(payload)
            const {data, success, error} = response

            if (!success) {
                return this.setState({
                    loading: false,
                    error
                }, () => {
                    Modal.error({
                        content: error,
                    })
                })
            }

            this.setState({
                data,
                loading: false
            }, () => {
                reloadListSessions()
            })
        } catch (e) {
            this.setState({
                error: e.message,
                loading: false
            }, () => {
                Modal.error({
                    content: e.message,
                })
            })
        }
    }

    render() {
        const {showModal, error, loading, data, reloadListSessions} = this.state

        return (
            <div>
                <Tooltip title="Xử lý lại file in">
                    <Button type='danger' onClick={this._handleReGen}>
                        <Icon type="redo"/>
                    </Button>
                </Tooltip>
                {(showModal && data.length > 0) && (
                    <ModalReGenerate loading={loading} showModal={showModal} closeModal={this._handleModal} data={data}
                                     onRefresh={this._handleRetryGenerate} error={error}
                                     reloadListSessions={reloadListSessions}/>
                )}
            </div>
        )
    }
}

JobReGenerate.propTypes = {
    sessionId: PropTypes.string.isRequired,
    reloadListSessions: PropTypes.func.isRequired
}

export default JobReGenerate
